import { DOCUMENT } from '@angular/common';
import { Location } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { CookieOptions } from '../cookies.options';

@Injectable()
export class CookiesService {
  private DEFAULT_PATH: string;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private location: Location,
  ) {
    this.DEFAULT_PATH = location.prepareExternalUrl('');
  }

  /**
   * Returns an Object containing all cookie entries
   *
   * @returns {{}}
   */
  public getAll() {
    const all = {};
    const cookieString = this.document.cookie;
    const cookies = cookieString.split(';');

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const index = cookie.indexOf('=');
      if (index > 0) {
        let name = decodeURIComponent(cookie.substring(0, index));

        name = name.trim();

        if (name) {
          let value = decodeURIComponent(cookie.substring(index + 1));

          try {
            value = JSON.parse(value);
          } catch (e) {
            value = decodeURIComponent(cookie.substring(index + 1));
          }
          all[name] = value || '';
        }
      }
    }
    return all;
  }

  /**
   * Return the value of a single cookie entry
   *
   * @param key
   * @returns {*|string}
   */
  public get(key) {
    const value = this.getAll()[key];
    return value || '';
  }

  /**
   * Creates/overwrites and try in the browsers cookies
   *
   * @param key
   * @param value
   * @param options
   */
  public set(key: string, value: any, options?: CookieOptions) {
    const cookie = [key + '=' + encodeURIComponent(value)];

    if (options) {
      if (options.path) {
        cookie.push('path=' + options.path);
      } else {
        cookie.push('path=' + this.DEFAULT_PATH);
      }

      if (options.maxAge) {
        cookie.push('max-age=' + options.maxAge);
      }
      // don't set max-age and let the cookie default to session
    } else {
      cookie.push('path=' + this.DEFAULT_PATH);
      // don't set max-age and let the cookie default to session
    }

    this.document.cookie = cookie.join('; ');
  }

  /**
   * Writes an empty value to the cookie and set
   * a max-age of 0 seconds to immediately expire
   *
   * @param key name of cookie
   * @param options optional CookieOptions
   */
  public expire(key: string, options?: CookieOptions) {
    const cookie = [key + '='];

    if (options && options.path) {
      cookie.push('path=' + options.path);
    } else {
      cookie.push('path=' + this.DEFAULT_PATH);
    }

    cookie.push('max-age=0');
    this.document.cookie = cookie.join('; ');
  }
} /* istanbul ignore next */
